import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import BaseHeaderComponent from "segments/desktop/header/layouts/base-header/base-header-component";
import LongFooterComponent from "segments/desktop/footer/layouts/long-footer/long-footer-component";
import WhatsNewPageItemsList from "../whats-new-items-list-component/whats-new-items-list";
import { StyledWhatsNewPageLayoutDesktopComponent } from "./whats-new-page-layout-desktop-component.scss";
import WhatsNewFirstFoldComponent from "../whats-new-first-fold-component/whats-new-first-fold-component";
const WhatsNewPageLayoutDesktopComponent = (props)=>{
    const { itemsArray, releaseHighlightsArray, monthlyVideosSet } = props;
    const slicedReleaseHighlightsArray = releaseHighlightsArray.slice(0, 6);
    return /*#__PURE__*/ _jsxs(StyledWhatsNewPageLayoutDesktopComponent, {
        className: "whats-new-page-component",
        children: [
            /*#__PURE__*/ _jsx(BaseHeaderComponent, {}),
            /*#__PURE__*/ _jsxs("div", {
                className: "whats-new-page-content",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "first-fold-wrapper",
                        children: /*#__PURE__*/ _jsx(WhatsNewFirstFoldComponent, {
                            releaseHighlightsArray: slicedReleaseHighlightsArray
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "items-list-wrapper",
                        children: /*#__PURE__*/ _jsx(WhatsNewPageItemsList, {
                            itemsArray: itemsArray,
                            monthlyVideosSet: monthlyVideosSet
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(LongFooterComponent, {})
        ]
    });
};
export default WhatsNewPageLayoutDesktopComponent;
